"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _MessageBoxContent = _interopRequireDefault(require("../MessageBoxContent"));
var _ChatPlaceholderError = _interopRequireDefault(require("../ChatPlaceholderError"));
var _MessageBoxLoading = _interopRequireDefault(require("../MessageBoxLoading"));
var _ChatPlaceholderSameUser = _interopRequireDefault(require("../ChatPlaceholderSameUser"));
var _ChatPlaceholderUserNotLogged = _interopRequireDefault(require("../ChatPlaceholderUserNotLogged"));
var _ChatPlaceholderAdExpired = _interopRequireDefault(require("../ChatPlaceholderAdExpired"));
var _ChatPlaceholderChatDisabled = _interopRequireDefault(require("../ChatPlaceholderChatDisabled"));
var _ChatPlaceholderNoInternetError = _interopRequireDefault(require("../ChatPlaceholderNoInternetError"));
var _types = require("../../../actions/types");
var _Header = _interopRequireDefault(require("../Header"));
var _actions = require("../../../actions");
var _selectors = require("../../../selectors");
var _platform = require("../../../helpers/platform");
var _ChatPlaceholderNotAvailable = _interopRequireDefault(require("../ChatPlaceholderNotAvailable"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function MessageBox(_ref) {
  var uiState = _ref.uiState,
    isAdview = _ref.isAdview,
    errorAction = _ref.errorAction,
    redirectUserToLoginPageAction = _ref.redirectUserToLoginPageAction,
    listId = _ref.listId,
    adStatus = _ref.adStatus,
    adSubject = _ref.adSubject,
    adImage = _ref.adImage,
    adPrice = _ref.adPrice;
  var renderPlaceholder = function renderPlaceholder(content, secondHidden) {
    var showHeader = _platform.isMsite || isAdview;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [showHeader && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Header["default"], {
        isAdview: isAdview,
        listId: listId,
        adSubject: adSubject,
        adPrice: adPrice,
        adImage: adImage,
        secondHidden: !_platform.isMsite || isAdview || secondHidden,
        adStatus: adStatus,
        isLoading: true
      }), content()]
    });
  };
  switch (uiState) {
    case _types.UI.USER_NOT_LOGGED:
      return renderPlaceholder(function () {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPlaceholderUserNotLogged["default"], {
          onClick: redirectUserToLoginPageAction
        });
      }, true);
    case _types.UI.USER_AD:
      return renderPlaceholder(function () {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPlaceholderSameUser["default"], {});
      }, true);
    case _types.UI.EXPIRED_AD:
      return renderPlaceholder(function () {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPlaceholderAdExpired["default"], {});
      }, true);
    case _types.UI.CHAT_DISABLED:
      return renderPlaceholder(function () {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPlaceholderChatDisabled["default"], {});
      }, true);
    case _types.UI.NOT_AVAILABLE:
      return renderPlaceholder(function () {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPlaceholderNotAvailable["default"], {});
      }, true);
    case _types.UI.NO_INTERNET:
      return renderPlaceholder(function () {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPlaceholderNoInternetError["default"], {
          onClick: errorAction
        });
      }, true);
    case _types.UI.LOADING:
      return renderPlaceholder(function () {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageBoxLoading["default"], {
          isAdview: isAdview
        });
      }, false);
    case _types.UI.LIST_MESSAGES:
    case _types.UI.FOCUS_CHAT_INPUT:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageBoxContent["default"], {
          isAdview: isAdview,
          listId: listId,
          adStatus: adStatus,
          adSubject: adSubject,
          adImage: adImage,
          adPrice: adPrice
        })
      });
    default:
      return renderPlaceholder(function () {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPlaceholderError["default"], {
          onClick: errorAction
        });
      }, true);
  }
}
MessageBox.propTypes = {
  uiState: _propTypes.string.isRequired,
  isAdview: _propTypes.bool.isRequired,
  errorAction: _propTypes.func.isRequired,
  redirectUserToLoginPageAction: _propTypes.func.isRequired,
  listId: _propTypes.string,
  adStatus: _propTypes.string,
  adSubject: _propTypes.string,
  adImage: _propTypes.string,
  adPrice: _propTypes.string
};
var mapStateToProps = function mapStateToProps(state) {
  var _getCurrentChat = (0, _selectors.getCurrentChat)(state),
    listId = _getCurrentChat.listId,
    adStatus = _getCurrentChat.adStatus,
    adSubject = _getCurrentChat.subject,
    adImage = _getCurrentChat.image,
    adPrice = _getCurrentChat.price;
  var uiState = state.ui.message;
  if (!listId && state.chatsLoaded) {
    uiState = _types.UI.NOT_AVAILABLE;
  } else if (state.ui.message === _types.UI.LOADING && (0, _selectors.alreadyLoadedMessages)(state)) {
    uiState = _types.UI.LIST_MESSAGES;
  } else if (state.ui.message === _types.UI.LIST_MESSAGES && !(0, _selectors.getCurrentRoomname)(state)) {
    uiState = _types.UI.LOADING;
  }
  return {
    uiState: uiState,
    listId: listId,
    adStatus: adStatus,
    adSubject: adSubject,
    adImage: adImage,
    adPrice: adPrice
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    redirectUserToLoginPageAction: _actions.redirectUserToLoginPage
  }, dispatch);
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps, mapDispatchToProps)(MessageBox);